import { Action } from './Action.js';
/**
 * @class Backward
 * @extends Action
 * @classdesc �������� �����
 * ����������� �� ������� �������� �����
 * */

export class Backward extends Action {		
	execute() {
		window.history.back();
	}       
}